import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialPieChartPollReport2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.945 7.625h-1.52V6.1h-1.52V4.575h-1.53v-1.53h-3.05v-1.52h-4.57v13.71h13.72v-4.57h-1.53Zm-1.52 4.57h-1.52v-3.05h-1.53v-1.52h-1.52V6.1h1.52v1.53h1.53v1.52h1.52Zm-3.05 9.14h1.53v3.05h-1.53Z\"/><path fill=\"currentColor\" d=\"M13.715 18.285V4.575h-3.05v1.52h1.52v13.72h13.72v1.52h1.52v-3.05zm9.14 6.1h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.52h-1.53Zm-3.04 1.52h3.04v1.53h-3.04Zm-7.62 1.53h7.62v1.52h-7.62Zm-3.05-1.53h3.05v1.53h-3.05Zm0-21.33h3.05v1.53h-3.05Zm-1.52 19.81h1.52v1.52h-1.52Zm0-18.28h1.52v1.52h-1.52Zm-1.53 16.76h1.53v1.52h-1.53Zm0-15.24h1.53v1.52h-1.53Zm-1.52 12.19h1.52v3.05h-1.52Zm0-10.67h1.52v3.05h-1.52Zm-1.52 3.05h1.52v7.62h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialPieChartPollReport2
